/* eslint-disable no-unused-vars */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, createTransform } from 'redux-persist';
import storageLocal from 'redux-persist/lib/storage'; // defaults to localStorage for web
import storageSession from 'redux-persist/lib/storage/session';
import auth from '../store/auth/auth';
import application from '../store/application';
import general from './campaign/general';
import targetingCampaign from './campaign/targeting';
import tracking from './campaign/tracking';
import manageCampaigns from './campaign/manageCampaigns';
import creatives from './campaign/creatives';
import targetingBrandsModels from '../store/targeting/targetingBrandsModels';
import targetingDevicesOs from '../store/targeting/targetingDevicesOs';
import targetingLanguages from '../store/targeting/targetingLanguages';
import targetingLocations from '../store/targeting/targetingLocations';
import targetingPlacements from 'store/targeting/targetingPlacements';
import manageApps from 'store/manageApps/manageApps';
import reports from 'store/publisherReports/reports';
import campaignReports from 'store/campaignReports/campaignReports';
import publisherReportsFiltersTable from './publisherReports/publisherReportsFiltersTable';
import formErrorsCampaign from 'store/campaign/formErrors';
import formErrorsSettings from 'store/accountSettings/formErrors';
import accountSettings from 'store/accountSettings/accountSettings';
import { creativesTrackingAPI } from 'services/creatives&trackingAPI.service';
import { manageAppsAPI } from 'services/manageApps.service';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';
import { searchLocationsCitysAPI } from 'services/searchLocationsCitysAPI.service';
import { globalAPI } from 'services/global.service';
import { manageCreativeMediaAPI } from 'services/manageCreativeMedia.service';
import { manageCampaignsAPI } from 'services/manageCampaigns.service';
import { campaignsManageAPI } from 'services/campaignsManage.service';
import { saveCampaignServiceAPI } from 'services/saveCampaign.service';
import { monthlyBudgetAPI } from 'services/monthlyBudget.service';
import { revenueReportsAPI } from 'services/reports.service';
import { dashboardAPI } from 'services/dashboard.service';
import { paymentsAPI } from 'services/payments.service';
import { accountSettingsAPI } from 'services/accountSettings.service';
import { campaignReportsAPI } from 'services/campaignReports.service';
import { localStorageMiddleware } from 'store/localStorage/localStorageMiddleware';
import payments from './payments/payments';
import chatWidget from './chatWidget/chatWidget';
import { authAPI } from 'services/newPlatformAuth.service';

const reducers = combineReducers({
  // Reports Page
  reports,
  publisherReportsFiltersTable,
  // Campaign Reports Page
  campaignReports,
  // Campaign Page
  auth,
  application,
  targetingCampaign,
  general,
  tracking,
  creatives,
  targetingBrandsModels,
  manageCampaigns,
  targetingDevicesOs,
  targetingLanguages,
  targetingLocations,
  targetingPlacements,
  //Manage Apps
  manageApps,
  [monthlyBudgetAPI.reducerPath]: monthlyBudgetAPI.reducer,
  [manageAppsAPI.reducerPath]: manageAppsAPI.reducer,
  //Auth
  [authAPI.reducerPath]: authAPI.reducer,
  //Creatives
  [creativesTrackingAPI.reducerPath]: creativesTrackingAPI.reducer,
  [manageCreativeMediaAPI.reducerPath]: manageCreativeMediaAPI.reducer,
  //searchExcludeAPI
  [searchExcludeAPI.reducerPath]: searchExcludeAPI.reducer,
  [searchLocationsCitysAPI.reducerPath]: searchLocationsCitysAPI.reducer,
  [manageCampaignsAPI.reducerPath]: manageCampaignsAPI.reducer,
  [campaignsManageAPI.reducerPath]: campaignsManageAPI.reducer,
  [accountSettingsAPI.reducerPath]: accountSettingsAPI.reducer,
  [saveCampaignServiceAPI.reducerPath]: saveCampaignServiceAPI.reducer,
  //Global
  [globalAPI.reducerPath]: globalAPI.reducer,
  //formErrorsCampaign
  //Reports
  [revenueReportsAPI.reducerPath]: revenueReportsAPI.reducer,
  [dashboardAPI.reducerPath]: dashboardAPI.reducer,
  formErrorsCampaign,
  accountSettings,
  formErrorsSettings,
  // Campaign Reports
  [campaignReportsAPI.reducerPath]: campaignReportsAPI.reducer,
  payments,
  [paymentsAPI.reducerPath]: paymentsAPI.reducer,
  chatWidget,
});

const transformExcludeField = createTransform(
  (inboundState, key) => {
    if (key === 'auth') {
      const { rememberMe, ...rest } = inboundState;
      return rest;
    }
    return inboundState;
  },
  (outboundState, key) => outboundState,
);

const persistConfig = {
  key: 'root',
  storage: storageLocal,
  //whitelist: ['auth', 'manageApps'],
  whitelist: ['manageApps'],
  //transforms: [transformExcludeField],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production' && {
    serialize: false,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    })
      .concat(creativesTrackingAPI.middleware)
      .concat(authAPI.middleware)
      .concat(manageAppsAPI.middleware)
      .concat(searchExcludeAPI.middleware)
      .concat(globalAPI.middleware)
      .concat(monthlyBudgetAPI.middleware)
      .concat(campaignsManageAPI.middleware)
      .concat(accountSettingsAPI.middleware)
      .concat(manageCampaignsAPI.middleware)
      .concat(manageCreativeMediaAPI.middleware)
      .concat(searchLocationsCitysAPI.middleware)
      .concat(saveCampaignServiceAPI.middleware)
      .concat(revenueReportsAPI.middleware)
      .concat(dashboardAPI.middleware)
      .concat(campaignReportsAPI.middleware)
      .concat(localStorageMiddleware)
      .concat(paymentsAPI.middleware),
});

export default store;
